// 💡 CAMBIO: El frontend ahora consume dinámicamente la configuración del asistente desde el backend
// 📁 RUTA: /var/www/frontend/edutech_react_funcional/src/pages/ChatPage.jsx

import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchChatResponse } from "../services/chatService";
import { Send } from "lucide-react";

const ChatPage = () => {
  const { assistantId } = useParams();
  const [messages, setMessages] = useState([]);
  const [message, setMessage] = useState("");
  const [asistenteConfig, setAsistenteConfig] = useState(null);

  useEffect(() => {
    const obtenerConfig = async () => {
      try {
        const res = await fetch(`${import.meta.env.VITE_BACKEND_URL}/asistentes/${assistantId.toUpperCase()}/config`);
        const data = await res.json();
        setAsistenteConfig(data);
        setMessages([{ text: data.mensajeInicial, sender: "system" }]);
      } catch (err) {
        console.error("Error al obtener config del asistente:", err);
      }
    };
    obtenerConfig();
  }, [assistantId]);

  const handleSend = async () => {
    if (message.trim()) {
      const userMsg = { text: message, sender: "user" };
      setMessages((prev) => [...prev, userMsg]);

      const response = await fetchChatResponse(
  user.email,
  assistantId,
  messages,
  chatId,
  userMsg.content // 👈 asegúrate que esta variable contiene el texto real
);
    
    
      setMessages((prev) => [...prev, response]);

      setMessage("");
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 dark:bg-gray-900 text-gray-900 dark:text-white flex flex-col items-center p-6">
      <h1 className="text-2xl font-semibold mb-4 capitalize">{assistantId} Chat</h1>

      {asistenteConfig?.banner && (
        <div className={`rounded-xl p-4 w-full max-w-xl mb-4 text-white bg-${asistenteConfig.banner.color}-800`}>
          <h2 className="text-lg font-bold">{asistenteConfig.banner.title}</h2>
          <p className="text-sm opacity-80">{asistenteConfig.banner.subtitle}</p>
        </div>
      )}

      <div className="bg-gray-800 text-white rounded-xl p-4 w-full max-w-xl shadow-md">
        <div className="h-64 overflow-y-auto space-y-2 mb-4">
          {messages.map((msg, idx) => (
            <div
              key={idx}
              className={`text-sm px-4 py-2 rounded-xl ${
                msg.sender === "user"
                  ? "bg-blue-600 text-right ml-auto"
                  : "bg-gray-700 text-left"
              }`}
            >
              {msg.text}
            </div>
          ))}
        </div>

        {asistenteConfig?.opcionesVisuales && (
          <div className="flex flex-wrap gap-2 mb-4">
            {asistenteConfig.opcionesVisuales.map((op, i) => (
              <button
                key={i}
                onClick={() => setMessage(op)}
                className="bg-blue-700 hover:bg-blue-800 text-white px-3 py-1 rounded-full text-sm"
              >
                {op}
              </button>
            ))}
          </div>
        )}

        <div className="flex gap-2">
          <input
            className="flex-1 bg-gray-700 text-white p-2 rounded-lg"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            placeholder="Escribe tu mensaje..."
          />
          <button onClick={handleSend}>
            <Send className="text-blue-400" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatPage;

